import { render, staticRenderFns } from "./bet-guide.vue?vue&type=template&id=a3a3b36c&scoped=true"
import script from "./bet-guide.vue?vue&type=script&lang=js"
export * from "./bet-guide.vue?vue&type=script&lang=js"
import style0 from "./bet-guide.vue?vue&type=style&index=0&id=a3a3b36c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a3b36c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3a3b36c')) {
      api.createRecord('a3a3b36c', component.options)
    } else {
      api.reload('a3a3b36c', component.options)
    }
    module.hot.accept("./bet-guide.vue?vue&type=template&id=a3a3b36c&scoped=true", function () {
      api.rerender('a3a3b36c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/help/help-rules/bet-guide.vue"
export default component.exports